import React, { useState } from 'react';

import TravelStepOne from './TravelSteps/TravelStepOne';
import TravelStepTwo from './TravelSteps/TravelStepTwo';
import './style.scss';
import TravelStepThree from './TravelSteps/TravelStepThree';
const TravelForm = ({
  setActiveStep,
  activeStep,
  t,
  ExtensionLimitDetailsEndpoint,
  GenerateOTPEndpoint,
  GenerateOTPToken,
  ExtraUserDetailsEndpoint,
  IsMockExtraUserDetailsEndpoint,
  IsMockGenerateOTPEndpoint,
  EditDatesFormEndpoint,
  IsMockVerifyOTPEndpoint,
  VerifyOTPEndpoint,
  DeleteTripEndpoint,

  limitationMessage,
timeoutErrorMessage,
verificationCodeExpiredErrorMessage,
timeout,
otpVerificationCode,
otpDidNotReceiveText,
otpSendNewCodeText,
}) => {
  const [extensionLimitDetails, setExtensionLimitDetails] = useState();
  const [generateOTPResponse, setGenerateOTPResponse] = useState();
  const [verifyOTPResponse, setVerifyOTPResponse] = useState();
  const [extraUserData, setExtraUserData] = useState();
  const [trips, setTrips] = useState([]);
  const [isDeleted, setIsDeleted] = useState({});
  const renderStep = () => {
    switch (activeStep) {
      case 1:
        return (
          <TravelStepOne
            setActiveStep={setActiveStep}
            ExtensionLimitDetailsEndpoint={ExtensionLimitDetailsEndpoint}
            extensionLimitDetails={extensionLimitDetails}
            setExtensionLimitDetails={setExtensionLimitDetails}
            GenerateOTPEndpoint={GenerateOTPEndpoint}
            IsMockGenerateOTPEndpoint={IsMockGenerateOTPEndpoint}
            GenerateOTPToken={GenerateOTPToken}
            ExtraUserDetailsEndpoint={ExtraUserDetailsEndpoint}
            IsMockExtraUserDetailsEndpoint={IsMockExtraUserDetailsEndpoint}
            generateOTPResponse={generateOTPResponse}
            setGenerateOTPResponse={setGenerateOTPResponse}
            setExtraUserData={setExtraUserData}
            extraUserData={extraUserData}
            trips={trips}
            setTrips={setTrips}
            DeleteTripEndpoint={DeleteTripEndpoint}
            t={t}
            isDeleted={isDeleted}
            setIsDeleted={setIsDeleted}
          />
        );
      case 2:
        return (
          <TravelStepTwo
            setActiveStep={setActiveStep}
            trips={trips}
            EditDatesFormEndpoint={EditDatesFormEndpoint}
            generateOTPResponse={generateOTPResponse}
            GenerateOTPToken={GenerateOTPToken}
            IsMockVerifyOTPEndpoint={IsMockVerifyOTPEndpoint}
            VerifyOTPEndpoint={VerifyOTPEndpoint}
            setVerifyOTPResponse={setVerifyOTPResponse}
            verifyOTPResponse={verifyOTPResponse}
            setGenerateOTPResponse={setGenerateOTPResponse}
            GenerateOTPEndpoint={GenerateOTPEndpoint}
            IsMockGenerateOTPEndpoint={IsMockGenerateOTPEndpoint}
            extraUserData={extraUserData}
            t={t}
            isDeleted={isDeleted}
            setIsDeleted={setIsDeleted}
            limitationMessage = {limitationMessage}
timeoutErrorMessage = {timeoutErrorMessage}
verificationCodeExpiredErrorMessage =  {verificationCodeExpiredErrorMessage}
timeout={timeout}
otpVerificationCode = {otpVerificationCode}
otpDidNotReceiveText = {otpDidNotReceiveText}
otpSendNewCodeText = {otpSendNewCodeText}
          />
        );

      case 3:
        return <TravelStepThree setActiveStep={setActiveStep} t={t} />;
      default:
        return null;
    }
  };
  return <div className="form">{renderStep()}</div>;
};

export default TravelForm;
